module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Miso-soup-51852ceac852fbfa0eb706af8f45729a.svg";